import React, { useEffect, useRef, useState } from 'react'
import LeftBar from '../Components/LeftBar'
import Topbar from '../Components/Topbar'
import profDefault from '../Images/def.png'
import defaultCover from '../Images/coverbg.jpg'
import { useNavigate } from 'react-router-dom'
import BottomNav from '../Components/BottomNav'
import Form from "react-bootstrap/Form"
import Spinner from 'react-bootstrap/Spinner';
import { Modal } from 'react-bootstrap'
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faTiktok, faYoutube, faLinkedin, faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons"
import ProgressBar from 'react-bootstrap/ProgressBar';
import { app } from "../firebase.js"
import { getStorage, ref, uploadBytes, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, updateDoc, getFirestore, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import swal from 'sweetalert';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { Link } from 'react-router-dom'

function SubscriptionSetup() {

    const [subscriptionEnabled, setSubscriptionEnabled] = useState(false);
    const [packageDetails, setPackageDetails] = useState(["", "", "", "", ""]);
    const [subscriptionPrice, setSubscriptionPrice] = useState("");

    const [saveButton5, setsaveButton5] = useState(true);
    const [updateButton5, setupdateButton5] = useState(false);

    const db = getFirestore(app);
    const [userId, setUserId] = useState()
    const auth = getAuth();
    const navigate = useNavigate();


    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const uid = user.uid;
                setUserId(uid)
                const docRef = doc(db, "users", uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();

                    if (data.subscriptionEnabled !== undefined) {
                        setSubscriptionEnabled(data.subscriptionEnabled);
                    }

                    if (data.packageDetails) {
                        setSubscriptionPrice(data.subscriptionPrice || "") // fill monthly price
                        setPackageDetails(data.packageDetails)       // fill the package details array
                    } else {
                        setSubscriptionEnabled(false)
                        setSubscriptionPrice("")
                        setPackageDetails(["", "", "", "", ""])     // default empty details
                    }



                } else {
                    console.log("No such document!");
                }
            } else {
                navigate("/login");
            }
        });

        return () => unsubscribe();
    }, [navigate, auth]);


    const handleToggle = (checked) => {
        if (checked) {
            swal("Info", "Fill in 5 mandatory package details to define what subscribers will get from you.", "info");
        }
        setSubscriptionEnabled(checked);
    };

    const saveSubscriptionSettings = () => {
        if (!subscriptionPrice || packageDetails.some(detail => !detail)) {
            swal("error", "All 5 package details and the monthly price are required", "error");
            return;
        }

        setsaveButton5(false)
        setupdateButton5(true)

        const userRef = doc(db, "users", userId);
        updateDoc(userRef, {
            subscriptionEnabled,
            subscriptionPrice,
            packageDetails
        }).then(() => {
            setsaveButton5(true)
            setupdateButton5(false)
            swal("success", "Subscription settings updated", "success").then(()=>{
                navigate("/profile")
            })
        }).catch((err) => {
            setsaveButton5(true)
            setupdateButton5(false)
            swal("error", "Failed to update subscription", "error");
            console.error(err);
        });
    };


    return (
        <div className='mainDashboard'>
            <div className="desktopOnly">
                <LeftBar />
            </div>

            <div className='mainContent'>



                <div className='editFormSection'>
                    <Form.Label className='sectionTitle'>Business Subscription Settings (Optional)</Form.Label>
                    <div className="alert alert-primary small">
                        <p>
                            Subscriptions allow your followers or businesses to pay a monthly fee to access exclusive services you offer.
                            By enabling subscriptions, you can monetize your influence, build a loyal audience, and provide consistent value.
                            Make sure to fill in all 5 package details and set a monthly price to define what subscribers will get.
                        </p>
                    </div>

                    <div className='subscription-toggle'>
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={subscriptionEnabled}
                                onChange={(e) => handleToggle(e.target.checked)}
                            />
                            <span className="slider round"></span>
                        </label>
                        <span>Enable Subscriptions</span>
                    </div>

                    {subscriptionEnabled && (
                        <>
                            <div className='subscription-field'>
                                <label>Monthly Price (KES)</label>
                                <input
                                    type="number"
                                    value={subscriptionPrice}
                                    onChange={(e) => setSubscriptionPrice(e.target.value)}
                                    placeholder="Set your monthly price"
                                />
                            </div>

                            <h4>Mandatory Package Details</h4>
                            {packageDetails.map((detail, index) => (
                                <div className='subscription-field' key={index}>
                                    <label>Package Detail {index + 1}</label>
                                    <input
                                        type="text"
                                        value={detail}
                                        onChange={(e) => {
                                            const updated = [...packageDetails];
                                            updated[index] = e.target.value;
                                            setPackageDetails(updated);
                                        }}
                                        placeholder={`Detail ${index + 1}`}
                                    />
                                </div>
                            ))}


                            <div className="subscription-info">
                                <p>
                                    Here, Zindua does not take 20 percent of your subscription earnings. Instead, we charge a flat rate of KES 1,000 per month to enable subscriptions. Save the changes, then go to Verify Account to <Link to="/verify-account">activate subscriptions.</Link>
                                </p>
                            </div>
                            {saveButton5 &&
                                <button className='saveBtn' type='button' onClick={saveSubscriptionSettings}>Save and Finish</button>
                            }
                            {updateButton5 &&
                                <Button variant="success" disabled className='saveBtn mt-3 mr-3'>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Updating Subscription...
                                </Button>
                            }
                        </>
                    )}
                    <button
                        type="button"
                        className="secondaryBtn"
                        onClick={() => navigate("/verify-account")} // previous page
                    >
                        finish
                    </button>
                </div>


            </div>

            <div className="mobileOnly">
                <BottomNav />
            </div>
        </div>
    )
}

export default SubscriptionSetup
